export default __webpack_public_path__ + "static/media/port-logo-amparo.12bda86d.webp";